// Значения формы поля «Название» точки входа (react-final-form) — 1:1
// ложатся в CreateStreamEntrypointInput/UpdateStreamEntrypointInput (см.
// CreateStreamEntrypointDialog.tsx/StreamEntrypointDialog.tsx).
export interface StreamEntrypointFormValues {
  title: string;
}

// Вкладки диалога точки входа (Task 6), по образцу STREAM_TABS
// (features/streams/model/types.ts): значение живёт в ?tab=.
export const ENTRYPOINT_TABS = ["edit", "broadcast", "monitoring"] as const;

export type StreamEntrypointTab = (typeof ENTRYPOINT_TABS)[number];
